import { EMedicalPermissions } from '@Enum/auth.enum'
import MedicalLayout from '@Layouts/Medical/MedicalLayout'
import React from 'react'
import { connect } from 'react-redux'

import { Route, Redirect } from 'react-router-dom'

interface IMedicalRoute {
    exact?: boolean
    path?: string
    user?: any
    component: any
}

const MedicalRoute: React.FC<IMedicalRoute> = ({
    component: Component,
    user,
    exact,
    path,
}) => {
    return (
        <Route
            exact={exact}
            path={path}
            render={(props: any) => {
                if (user?.permissions?.includes(EMedicalPermissions?.LOGIN)) {
                    return (
                        <MedicalLayout>
                            <Component {...props} />{' '}
                        </MedicalLayout>
                    )
                }
                return (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {
                                from: props.location,
                            },
                        }}
                    />
                )
            }}
        />
    )
}

const mapStateToProps = (state: any) => {
    const { user } = state?.auth

    return {
        user,
    }
}

export default connect(mapStateToProps, null)(MedicalRoute)
